<template>
	<div>
		<Button
			data-test="withdraw-application-trigger"
			:aria-label="$t(copy.action)"
			v-tooltip="compact ? $t(copy.action) : null"
			:type="buttonType"
			:size="size"
			:icon-component="copy.icon"
			:icon-only="compact"
			:disabled="loading"
			@click="openConfirmation"
		>
			<template v-if="!compact">
				{{ $t(copy.action) }}
			</template>
		</Button>

		<ModalV2
			v-model="showConfirmation"
			hide-header
			size="sm"
			variant="danger"
			:close-on-backdrop="!loading"
			:close-on-esc="!loading"
			:labelled-by="titleId"
			panel-class="max-w-[440px] whitespace-normal text-left rounded-xl border border-black/10 shadow-xl"
			body-class="min-w-0 p-6 overflow-visible"
		>
			<div class="flex flex-col gap-6">
				<div class="flex flex-col gap-3">
					<h3
						:id="titleId"
						class="mb-0 font-sans text-lg font-semibold normal-case text-grey-1000"
					>
						{{ $t(copy.title) }}
					</h3>

					<p class="mb-0 w-full break-words text-base text-grey-900">
						{{ $t(copy.prefix) }}
						<strong>{{ resolvedJobOfferName }}</strong>
						{{ $t(copy.suffix) }}
					</p>
				</div>

				<div
					class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end"
				>
					<Button type="secondary" :disabled="loading" @click="close">
						{{ $t('crud.cancel') }}
					</Button>
					<Button
						data-test="withdraw-application-confirm"
						type="danger"
						:disabled="loading"
						@click="confirm"
					>
						{{ $t(copy.confirm) }}
					</Button>
				</div>
			</div>
		</ModalV2>
	</div>
</template>

<script>
import Button from '~/components/ui/common/Button'
import ModalV2 from '~/components/Modal/ModalV2'
import { getCandidateDenialActionCopy } from '~/utils/applicantApplicationStage'

export default {
	name: 'WithdrawApplicationAction',
	components: {
		Button,
		ModalV2
	},
	props: {
		application: {
			type: Object,
			required: true
		},
		jobOfferName: {
			type: String,
			default: null
		},
		compact: {
			type: Boolean,
			default: false
		},
		buttonType: {
			type: String,
			default: 'danger-light'
		},
		size: {
			type: String,
			default: null
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showConfirmation: false,
			titleId: `withdraw-application-title-${this._uid}`
		}
	},
	computed: {
		copy() {
			return getCandidateDenialActionCopy(this.application)
		},
		resolvedJobOfferName() {
			return (
				this.jobOfferName ||
				this.application?.job_offer?.name ||
				this.$t('general.job-offer')
			)
		}
	},
	methods: {
		openConfirmation() {
			if (!this.loading) {
				this.showConfirmation = true
			}
		},
		close() {
			if (!this.loading) {
				this.showConfirmation = false
			}
		},
		confirm() {
			if (this.loading) {
				return
			}

			this.showConfirmation = false
			this.$emit('update', this.application.id, 'denied')
		}
	}
}
</script>
